"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_community(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9ca340f-7476-491f-8b8b-c33cc4aeff44",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 144 141.01"
  }, props), /*#__PURE__*/React.createElement("title", null, "main_icn_Community_or_Foundation"), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 119.18,
    r: 17.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.17,
    cy: 66.78,
    r: 17.83,
    transform: "translate(-37.81 47.54) rotate(-30)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.83,
    cy: 66.78,
    r: 17.83,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -58.92, 38.58)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.59,151a58,58,0,0,0,27.51-18.87",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,132.08a58,58,0,0,0,27.49,18.87",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.39,83.39A58.05,58.05,0,0,0,42,116.65",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,38.5A57.71,57.71,0,0,0,57,52.91",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,52.9A57.71,57.71,0,0,0,104.91,38.5",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,116.65a58.05,58.05,0,0,0,2.58-33.25",
    transform: "translate(-24 -34.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_community;
exports.default = _default;